export type LiveSessionCopyLibrary = {
  id: string;
  name: string;
  duration_seconds: number;
  format: string;
  language: string;
  start_time?: number | null;
  end_time?: number | null;
  base_video_url?: string | null;
};

export type LiveSessionCopySource = {
  library?: LiveSessionCopyLibrary | null;
};

export type CopyLibraryDialogLibrary = {
  name: string;
  base_video_url?: string | null;
  duration_seconds: number;
  format: string;
  language: string;
  start_time?: number | null;
  end_time?: number | null;
  source_library_id: string | null;
};

export function liveSessionToCopyLibrary(
  session: LiveSessionCopySource,
): CopyLibraryDialogLibrary | null {
  const library = session.library;
  if (!library?.id || !library.base_video_url) return null;

  return {
    name: library.name,
    base_video_url: library.base_video_url,
    duration_seconds: library.duration_seconds,
    format: library.format,
    language: library.language,
    start_time: library.start_time,
    end_time: library.end_time,
    source_library_id: library.id,
  };
}
